import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-f5692136"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "container pl-sm-3 pr-sm-2 pr-0 pl-0 [ heightInherit ]" };
const _hoisted_2 = { class: "row no-gutters [ heightInherit ]" };
const _hoisted_3 = { class: "col-7 overflow-hidden d-flex align-items-center [ heightInherit ]" };
const _hoisted_4 = ["src", "alt"];
const _hoisted_5 = { class: "strong h6 h6-productName" };
const _hoisted_6 = { class: "col-5 d-flex align-items-center justify-content-end [ heightInherit ]" };
const _hoisted_7 = { class: "d-flex flex-column align-items-end" };
const _hoisted_8 = { class: "d-inline-block stronger h3 h3-menuPrice pt-1" };
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "d-inline-block font8" }, "inkl. MwSt.", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    var _a, _b, _c, _d;
    const _component_blue_add_cart = _resolveComponent("blue-add-cart");
    return (_ctx.currentProduct)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass([{ headerMenuDown: _ctx.scrollDown }, "headerMenuProductDetailPage container-fluid bg-white border-bottom overflow-hidden d-md-block d-none"])
        }, [
            _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("img", {
                            src: (_a = _ctx.currentProduct) === null || _a === void 0 ? void 0 : _a.mainImage,
                            title: "Produktfoto",
                            class: "mr-7",
                            width: "60",
                            height: "60",
                            style: { "object-fit": "contain" },
                            alt: (_b = _ctx.currentProduct) === null || _b === void 0 ? void 0 : _b.name
                        }, null, 8, _hoisted_4),
                        _createElementVNode("div", _hoisted_5, _toDisplayString((_c = _ctx.currentProduct) === null || _c === void 0 ? void 0 : _c.name), 1)
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("span", _hoisted_8, _toDisplayString((_d = _ctx.currentProduct) === null || _d === void 0 ? void 0 : _d.currentPrice) + " € ", 1),
                            _hoisted_9
                        ]),
                        _createVNode(_component_blue_add_cart, {
                            class: "ml-4 extraButtonStyling",
                            style: {}
                        })
                    ])
                ])
            ])
        ], 2))
        : _createCommentVNode("", true);
}
